module.exports = __webpack_public_path__ + "img/shape.5be90730.svg";